/* global localStorage */

import axios from 'axios'

const API_URL = process.env.API_URL || './exoops'

export default axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }
})
